import { queryKeys } from '../../queryKeys';
import { useQuery } from '../base';

export function useQuestionnaireSubmissionById({
  organizationId,
  enabled = true,
  id,
}: {
  id?: null | string;
  organizationId?: string;
  enabled?: boolean;
}) {
  const { queryFn, queryKey } = queryKeys.questionnaireSubmissions.fetchById({
    organizationId,
    id: id ?? '',
  });
  return useQuery({ enabled: enabled && !!id, queryFn, queryKey });
}
